import AdmissionsOverview from "../components/sections/home/AdmissionsOverview";
import EnquiryCTA from "../components/sections/home/EnquiryCTA";
import HeroSection from "../components/sections/home/HeroSection";
import ProcessPreview from "../components/sections/home/ProcessPreview";
import WhyChooseSection from "../components/sections/home/WhyChooseSection";
import PageMeta from "../components/ui/PageMeta";
import { homeMeta } from "../data/homepage";

function Home() {
  return (
    <>
      <PageMeta title={homeMeta.title} description={homeMeta.description} />
      <HeroSection />
      <AdmissionsOverview />
      <WhyChooseSection />
      <ProcessPreview />
      <EnquiryCTA />
    </>
  );
}

export default Home;
